import {  Box,Button, Card, Dialog, DialogTitle, DialogContent, AppBar, Toolbar,
    CarContent, Paper, Grid, CardContent, Typography, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import GaugeChart from 'react-gauge-chart';
import { useEffect, useState } from "react";

import { Spacing } from "@mui/system";

import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { IconButton } from '@material-ui/core';
import HelpCenterTwoToneIcon from '@mui/icons-material/HelpCenterTwoTone';

import { useTranslation } from "react-i18next";
import useStyles from './styles';
import { debugLog } from '../../../common/debugUtilities';
const gridContainer = {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)"
  };
  
  /**
   * This approach works best if you have a variable number of columns at runtime.
   * Replace `gridContainer` with `gridContainer2` at line 27 to give it a try.
   */
  const gridContainer2 = {
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoRows: "1fr",
    gridAutoFlow: "column"
  };
  const gridContainerRow = {
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoRows: "1fr",
    gridAutoFlow: "row",
    p:"4"
  };
  const gridItem = {
    margin:'12px'
  };

  

export default function ReportMetricsGrid (props) {

    const {t, i18n} = useTranslation();
    const {isOpen, assessment, dialogComplete} = props;

    // Helper function to format ordinal numbers (1st, 2nd, 3rd, etc.)
    const getOrdinal = (n) => {
        const s = ["th", "st", "nd", "rd"];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    const [headTurn, setHeadTurn] = useState(0.5);
    const [videoQuality, setVideoQuality] = useState(0);
    const [upperBodySym, setUpperBodySym] = useState(0);
    const [upperBodySymPercent, setUpperBodySymPercent] = useState(0);
    const [lowerBodySym, setLowerBodySym] = useState(0);
    const [lowerBodySymPercent, setLowerBodySymPercent] = useState(0);
    const [motorRisk, setMotorRisk] = useState(0);
    const [percentile, setPercentile] = useState(50);
    const [classification, setClassification] = useState('typical');

    const classes = useStyles();

    const cardStyle = {
        display:'block',
      };

    useEffect( ()=>{
        debugLog('Current asmt metrics:', assessment?.notes);
        computeSingleHeadTurn();
        if (assessment){
            if (assessment?.notes?.quality_index){
                setVideoQuality( (assessment?.notes?.quality_index).toFixed(2));
            }
            if (assessment?.notes?.uppersym){
                setUpperBodySym( (assessment?.notes?.uppersym/100).toFixed(2));
                setUpperBodySymPercent( (assessment?.notes?.uppersym).toFixed(1));
            }
            if (assessment?.notes?.lowersym) {
                setLowerBodySym( (assessment?.notes?.lowersym/100).toFixed(2));
                setLowerBodySymPercent((assessment?.notes?.lowersym).toFixed(1));
            }
            if (assessment?.notes?.p){
                setMotorRisk( assessment?.notes?.p.toFixed(2));
            }
            if (assessment?.notes?.percentile !== undefined){
                setPercentile(assessment?.notes?.percentile);
            }
            if (assessment?.notes?.classification){
                setClassification(assessment?.notes?.classification);
            }

        }
    },[assessment]);

    const computeSingleHeadTurn = ()=>{
        if(!assessment?.notes) { return;}
        const left = assessment?.notes?.head_turn_left / 100;
        const right = assessment?.notes?.head_turn_right / 100;
        const center = assessment?.notes?.head_turn_center / 100;
        // start at 50%
        let turn = 0.5;
        turn = turn-left/2;
        debugLog('Turn:', turn);
        turn = turn + right/2;
        debugLog('Turn:', turn);
        debugLog('[ReportGrid] Setting turn to:', turn);
        setHeadTurn(turn);

    };


    const showHeadTurnArticle = () => {
        const url = 'https://blog.earlymarkers.com/2023/05/head-turn-preference.html';
        window.open(url,'_blank');
       
    };

    const showSymmetryArticle = () => {
        const url = 'https://blog.earlymarkers.com/2023/05/symmetry-of-limb-poses-in-crib.html';
        window.open(url,'_blank');
       
    };

    const showMotorRiskArticle = () => {
        const url = "https://blog.earlymarkers.com/2023/05/neuromotor-risk-probability-from.html";
        window.open(url,'_blank');
    }

    return (
        
    <Dialog open={isOpen} fullScreen className={classes.paper}>
    
    
    <DialogContent>
    <AppBar className={classes.appbar}>
        <Toolbar>

            <IconButton
                edge="start"
                color="inherit"
                aria-label="close"
                onClick={dialogComplete}
                >
                <CloseIcon />
                </IconButton>
                <Typography variant="h6" component="div">
                {t('appbar', {ns:"report"})}
                </Typography>
        </Toolbar>
    </AppBar>
        <Card>
        <CardContent>
        <Typography variant="h6" component="div">
        {t('appbar', {ns:"report"})}
        </Typography>
        <Grid container direction="row" spacing={1} alignItems="stretch" >

        
        <Grid item xs={10} sm={10} md={10} lg={10} style={{display: 'flex'}}>

            {/* <Typography variant="h4">{t('title',{ns:'report'})}</Typography> */}
        </Grid>
        <Grid item xs={10} sm={10} md={10} lg={10} style={{display: 'flex'}}>
            <Typography color="secondary">
            {t('subtitle1',{ns:'report'})} <b>{t('subtitle2',{ns:'report'})}</b> {' '}
            {t('subtitle3',{ns:'report'})}.
            </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4} sm={3}>
                            <GaugeChart id="chart1" animate={false}
                            percent={videoQuality}
                            nrOfLevels={25} textColor="#FFF" needleColor="#464A4F"
                            colors={['#EA4228', '#F5CD19', '#5BE12C']}
                            style={{width: '100px'}}/>
                        </Grid>
                        <Grid item xs={8} sm={9}>
                            <Typography variant="h6">{t('videoq',{ns:'report'})}</Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    {t('videoqpara',{ns:'report'})}.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </Grid>



        <Grid item xs={12} sm={12} md={12}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4} sm={3}>
                            <GaugeChart id="chart2" hideText animate={false}
                            percent={headTurn}
                            nrOfLevels={3} textColor='#5BE12C' needleColor="#464A4F"
                            colors={['#F5CD19', '#5BE12C', '#F5CD19']}
                            style={{width: '100px'}}/>
                        </Grid>
                        <Grid item xs={8} sm={9}>
                            <Typography variant="h6">{t('headturn',{ns:'report'})}</Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography paragraph>
                    {t('headturnpara',{ns:'report'})}.
                    </Typography>
                    <Button size="small" variant="outlined" color="secondary"
                        onClick={showHeadTurnArticle}> {t('learnmore',{ns:'report'})}</Button>
                </AccordionDetails>
            </Accordion>
        </Grid>



        <Grid item xs={12} sm={12} md={12}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4} sm={3}>
                            <GaugeChart id="chart3" percent={upperBodySym} hideText animate={false}
                            nrOfLevels={3} textColor="#FFF" needleColor="#464A4F"
                            colors={['#F5CD19', '#f5ee19', '#5BE12C']}
                            style={{width: '100px'}}/>
                        </Grid>
                        <Grid item xs={8} sm={9}>
                            <Typography variant="h6">{t('uppersym',{ns:'report'})}</Typography>
                            <Typography variant="body2" color="textSecondary">
                                {t('uppersympara2',{ns:'report'})}: {upperBodySymPercent}%
                            </Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Box>
                        <Typography paragraph>
                        {t('uppersympara1',{ns:'report'})}.
                        </Typography>
                        <Button size="small" variant="outlined" color="secondary"
                            onClick={showSymmetryArticle}> {t('learnmore',{ns:'report'})}</Button>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>



        <Grid item xs={12} sm={12} md={12}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4} sm={3}>
                            <GaugeChart id="chart4" percent={lowerBodySym} animate={false}
                            hideText
                            nrOfLevels={3} textColor="#FFFFFF" needleColor="#464A4F"
                            colors={['#F5CD19', '#f5ee19', '#5BE12C']}
                            style={{width: '100px'}}/>
                        </Grid>
                        <Grid item xs={8} sm={9}>
                            <Typography variant="h6">{t('lowersym',{ns:'report'})}</Typography>
                            <Typography variant="body2" color="textSecondary">
                                {t('lowersympara2',{ns:'report'})}: {lowerBodySymPercent}%
                            </Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography paragraph>
                    {t('lowersympara1',{ns:'report'})}.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <Typography variant="h6">{t('neuroindex',{ns:'report'})}</Typography>
                            <Typography variant="h4" style={{
                                fontWeight: 'bold',
                                color: classification === 'at_risk' ? '#F5CD19' : '#5BE12C',
                                marginTop: '8px'
                            }}>
                                {getOrdinal(percentile)} {t('percentile',{ns:'report'})}
                            </Typography>

                            {/* Linear gauge in summary */}
                            <Box style={{margin: '12px 0'}}>
                                <Box style={{
                                    position: 'relative',
                                    height: '12px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '6px',
                                    overflow: 'hidden'
                                }}>
                                    <Box style={{
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: `${percentile}%`,
                                        backgroundColor: classification === 'at_risk' ? '#F5CD19' : '#5BE12C',
                                        borderRadius: '6px',
                                        transition: 'width 0.3s ease'
                                    }}></Box>
                                    <Box style={{
                                        position: 'absolute',
                                        left: `${percentile}%`,
                                        top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        width: '16px',
                                        height: '16px',
                                        backgroundColor: '#fff',
                                        borderRadius: '50%',
                                        border: `2px solid ${classification === 'at_risk' ? '#F5CD19' : '#5BE12C'}`,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                    }}></Box>
                                </Box>
                                <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: '4px'}}>
                                    <Typography variant="caption">0</Typography>
                                    <Typography variant="caption">50</Typography>
                                    <Typography variant="caption">100</Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Box>
                        <Box style={{
                            padding: '16px',
                            backgroundColor: classification === 'at_risk' ? '#FFF3E0' : '#E8F5E9',
                            borderRadius: '8px',
                            marginBottom: '16px'
                        }}>
                            <Typography variant="body1" style={{fontWeight: 'bold', marginBottom: '8px'}}>
                                {classification === 'at_risk'
                                    ? t('followuprecommended',{ns:'report'})
                                    : t('withinexpectedrange',{ns:'report'})
                                }
                            </Typography>
                            <Typography variant="body2">
                                {t('neuroindexpara1',{ns:'report'})}
                            </Typography>
                        </Box>

                        <Typography variant="caption" color="textSecondary" style={{display: 'block', marginBottom: '8px'}}>
                            {t('screeningnotdiagnosis',{ns:'report'})}
                        </Typography>

                        <Button size="small" variant="outlined" color="secondary"
                            onClick={showMotorRiskArticle}> {t('learnmore',{ns:'report'})}</Button>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
        </Grid>
        </CardContent>
        </Card>
    </DialogContent>
    
    </Dialog>
    
    )
    
}